import { createFileRoute, redirect } from "@tanstack/react-router";

// Consolidated statements → Trial Balance (closest system report)
export const Route = createFileRoute("/_auth/reports/consolidated")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "d536b772-0de4-532c-954b-050552e17746" }, replace: true });
  },
  component: () => null,
});
